const ROUTE_CALCULATOR_API_OPTIONS = {
  AWS: 'AWS',
  GOOGLE: 'Google',
}

export { ROUTE_CALCULATOR_API_OPTIONS }
